<template>
  <qc-container title="售后管理">
    <page-request ref="table" url="/api/business/order/refund/findByPage" :table-header="tableHeader" :expend="expend" :prop="{shopType:0,status:status}" :op-width="200">
      <div class="flex-cc full">
        <el-tabs v-model="activeName">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="待处理" name="1"></el-tab-pane>
          <el-tab-pane label="待寄回" name="2"></el-tab-pane>
          <el-tab-pane label="已完成" name="3"></el-tab-pane>
          <el-tab-pane label="已关闭" name="4"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <export-excel @action="addExportTask" ref="exportExcel" file-name="refund-export.xlsx" task-key="refund" task-name="售后列表" button-name="批量导出"></export-excel>
        </div>
      </div>
      <template #op="scope">
        <b-button v-if="scope.row.orderStatus==1 ||scope.row.orderStatus==7" @click="toDetail(scope.row)">{{scope.row.type?'退货':'退款'}}审核</b-button>
        <b-button v-else-if="scope.row.orderStatus==6" @click="toDetail(scope.row)">确认收货</b-button>
        <b-button v-else @click="toDetail(scope.row)">详情</b-button>
      </template>
    </page-request>
  </qc-container>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import TButton from "@/components/el/t-button.vue";
import BButton from "@/components/el/b-button.vue";
import ExportExcel from "@/components/base/ExportExcel.vue";

export default {
  name: "refund",
  components: {ExportExcel, BButton, TButton, PageRequest, QcContainer},
  data() {
    return {
      activeName:"0",
      tableHeader: [
        {label: "售后编号", prop: "code",width:200},
        {type: "goodsList", label: "商品",prop:"goodsList",minWidth:400,status:"false"},
        {prop: "payMoney", label: "退款金额",width:100},
        {type: "refund", label: "售后",width:300},
        {prop: "orderStatusDesc", label: "状态",width:160},
        {prop: "createTime", label: "申请时间",width:160}
      ],
      expend:[
        {label: "售后编号", prop: "code"},
        {label: "订单编号", prop: "orderOgCode"},
        {label: "商品名称", prop: "goodsName"},
        {label: "商品编码", prop: "goodsCodes"},
        {label: "收货人", prop: "deliveryName"},
        {label: "收货电话", prop: "mobile"},
        {label: "收货地址", prop: "address"},
        {label: "售后类型", prop: "type",type:"select",options:[{"label":"退款","value":"0"},{"label":"退款退货","value":"1"}]},
        {label: "申请时间", start: "startTime", end: "endTime", type: "daterange"},
      ],
    }
  },
  computed:{
    status(){
      if(this.activeName==1){
        return 0;
      }else if(this.activeName==2){
        return 2;
      }else if(this.activeName==3){
        return 1;
      }else{
        return null;
      }
    },
  },
  mixins: [tableBase],
  methods: {
    toDetail(row){
      this.toRouter("/index/refund/detail",{id:row.id});
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
